import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

const PaymentCancel = () => {
  return (
    <div data-testid="payment-cancel-page" className="bg-cream">
      <Seo title="Checkout Cancelled" noindex />
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-28 text-center">
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight text-ink mb-4">
          No charge was made.
        </h1>
        <p className="text-lg sm:text-xl text-ink/80 mb-10">
          Your checkout was cancelled before payment. Your deck will be here whenever you are ready.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/seniors#program"
            data-testid="cancel-back-to-program-link"
            className="inline-flex items-center justify-center bg-sage text-white hover:bg-sage-dark rounded-full px-8 py-4 text-lg font-medium transition-all duration-300"
          >
            Back to UNSTUCK Seniors
          </Link>
          <Link
            to="/"
            data-testid="cancel-home-link"
            className="inline-flex items-center justify-center border-2 border-sage text-sage hover:bg-sage hover:text-white rounded-full px-8 py-4 text-lg font-medium transition-all duration-300"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
